import { useCopilotAction } from '@copilotkit/react-core'

import { EventTypes, dispatch } from 'modules/core/lib/pubSub'

/**
 * Notify the frontend that a backend-executed mutation has completed.
 * Re-broadcast via PubSub so subscribers can refresh / refetch.
 */
export const useNotifyMutationExecutedAction = () => {
  useCopilotAction({
    name: 'notifyMutationExecuted',
    available: 'remote',
    followUp: false,
    description: 'Notify the frontend that a backend-executed mutation has completed.',
    parameters: [
      {
        name: 'operationName',
        description: 'The GraphQL mutation operation name.',
        required: true,
      },
      {
        name: 'variables',
        description: 'The GraphQL mutation variables used to execute the mutation.',
        type: 'object',
        required: false,
      },
      {
        name: 'result',
        description: 'The raw GraphQL mutation result payload.',
        type: 'object',
        required: false,
      },
    ],
    handler: async ({ operationName, variables, result }) => {
      if (!operationName) {
        return 'Mutation notification skipped because operationName is missing.'
      }

      dispatch({
        type: EventTypes.ONE_MUTATION_EXECUTED,
        data: {
          operationName,
          variables,
          result,
        },
      })

      return 'Mutation notification dispatched successfully.'
    },
  })
}
